import {ExpenseType} from "@/models/Enums";

export default class SaveExpenseRequest {
    public id : string | null = null;

    public name: string | null = null;

    public productExternalId: string | null = null;

    public equipmentType: string | null = null;

    public hourlyInvoiced: boolean = false;

    public isInvoiceable: boolean = false;

    public type: ExpenseType = ExpenseType.Unknown;
}